export default __webpack_public_path__ + "static/media/PrimeraV.9b9bebec.jpg";